<template>
	<v-app id="zarinpalCallback-view" fluid tag="section">
		<v-app-bar color="secondary" dark dense style="max-height: 48px">
			<v-toolbar-title>
				<img src="/logo-wide.png" style="float: right;max-width: 100px;max-height: 50px;" />
				<strong class="mr-1 font-weight-black">بررسی اطلاعات جهت هدایت به درگاه پرداخت</strong>
				&nbsp;
				<span class="warning--text">{{ longTitle }}</span>
			</v-toolbar-title>
		</v-app-bar>
		<v-container>
			<v-row justify="center" class="my-12">
				<v-col cols="12" md="6" v-if="loading || !isSuccess">
					<v-card class="mx-auto">
						<div class="d-flex flex-column justify-center align-center" style="height:200px;" :style="{ 'background-color': bg }">
							<v-icon size="large" :color="color" style="font-size: 100px;">
								{{ icon }}
							</v-icon>
						</div>
						<div class="form-group text-center pa-5">
							<div v-if="message" v-html="message">

							</div>
						</div>
					</v-card>
				</v-col>
				<v-col cols="12" md="7" v-if="!loading && isSuccess">
					<v-card class="">
						<div class="form-group text-right pa-5">
							<p class="text-body blue--text" style="text-align: justify;">کاربر گرامی شما در حال آماده سازی جهت پرداخت قسط با مشخصات زیر هستید، لطفا پس از بررسی و اطمینان از صحت اطلاعات اقدام به پرداخت نمایید.</p>
							<div class="my-2">
								<span>پذیرنده:</span><span class="grey--text mr-2">{{ data.customer }}</span>
							</div>
							<div class="my-2">
								<span>مشخصات شما:</span><span class="grey--text mr-2">{{ data.member }}</span>
							</div>
							<div class="my-2">
								<span>عنوان وام:</span><span class="grey--text mr-2">{{ data.loanTitle }}</span>
							</div>
							<div class="my-2">
								<span>کد وام:</span><span class="grey--text mr-2">{{ data.loanCode }}</span>
							</div>
							<div class="my-2">
								<span>شماره قسط:</span><span class="grey--text mr-2">{{ data.installmentNumber }}</span>
							</div>
						</div>
					</v-card>
				</v-col>
				<v-col cols="12" md="5" v-if="!loading && isSuccess">
					<online-payment ref="onlinePayment" v-if="true" :data="userLoanPayment" :showLoanDetail="false" />
				</v-col>
			</v-row>
		</v-container>
	</v-app>
</template>

<script>
	import OnlinePayment from '@/components/forms/OnlinePayment.vue'
	import { get } from 'vuex-pathify'
	import api from '@/util/app-api'
	import ThemeManager from '@/util/theme-manager.js'

	const INVALIDMSG = 'اطلاعات معتبر نمی باشد'
	export default {
		name: 'PreOnlinePayment',
		components: {
			'online-payment': OnlinePayment,
		},
		data() {
			return {
				userLoanPayment: null,
				data: { customer: '', member: '', loanTitle: '', loanCode: '', installmentNumber: '' },
				loading: false,
				isSuccess: null,
				message: '',
			}
		},
		computed: {
			...get('siteConfig', [
				'longTitle'
			]),
			bg() {
				if (this.loading)
					return '#dadada'
				if (this.isSuccess)
					return 'rgb(182 255 193)'
				return 'rgb(255 227 227)'
			},
			color() {
				if (this.loading)
					return '#aaa'
				if (this.isSuccess)
					return '#0dd400'
				return '#ff5722'
			},
			icon() {
				if (this.loading)
					return 'mdi-timer-sand'
				if (this.isSuccess)
					return 'mdi-credit-card-check'
				return 'mdi-alert-circle-outline'
			},
			title() {
				if (this.loading)
					return 'در حال بررسی'
				if (this.isSuccess)
					return 'پرداخت موفق'
				return 'پرداخت ناموفق'
			}
		},
		created() {
			ThemeManager.ApplyThemeSettings(this.$route.params.customerCode || 0, this.$vuetify)
		},
		mounted() {
			if (!this.$route.params.customerCode || !this.$route.params.loanPaymentCode) {
				this.message = INVALIDMSG
				return
			}
			this.verify()
			// this.$refs.password.$el.querySelector('input').click()
		},
		methods: {
			verify() {
				this.message = 'در حال دریافت اطلاعات، لطفا تا پایان عملیات منتظر بمانید...'
				this.loading = true
				let data = {
					customerCode: this.$route.params.customerCode,
					loanPaymentCode: this.$route.params.loanPaymentCode
				}
				api.post('memberPurchase/PreOnlinePayment', data, { authHeader: false, contentType: 'application/json' })
					.then(response => {
						this.isSuccess = true
						this.userLoanPayment = { payment: response.userLoanPayment, userLoanModel: response.userLoanPayment.userLoanModel, customerCode: data.customerCode }
						this.data.customer = response.customer
						this.data.member = response.member
						this.data.loanTitle = response.userLoanPayment.userLoanModel.loanModel.title
						this.data.loanCode = response.userLoanPayment.userLoanModel.code
						this.data.installmentNumber = response.userLoanPayment.installmentNumber
					})
					.catch(error => {
						this.isSuccess = false
						this.message = error.message || error.toString()
					})
					.finally(() => {
						this.loading = false
					})
			},
			returnToPanel() {
				this.$router.push('/member/dashboard')
			}
		},
	}
</script>

<style scoped></style>
